/* eslint-disable */
export default {
  forward: 'Reenviar',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
